/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
const editorIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<rect x="2" y="2" width="20" height="20" fill="none" stroke="black" stroke-width="1" />

		<rect x="4" y="5" width="2" height="2" fill="none" stroke="black" stroke-width="1" />
		<text x="8" y="6" font-family="Arial" font-size="2" fill="black">Task 1</text>

		<rect x="4" y="10" width="2" height="2" fill="none" stroke="black" stroke-width="1" />
		<text x="8" y="11" font-family="Arial" font-size="2" fill="black">Task 2</text>

		<rect x="4" y="15" width="2" height="2" fill="none" stroke="black" stroke-width="1" />
		<text x="8" y="16" font-family="Arial" font-size="2" fill="black">Task 3</text>

		<rect x="4" y="20" width="2" height="2" fill="none" stroke="black" stroke-width="1" />
		<text x="8" y="21" font-family="Arial" font-size="2" fill="black">Task 4</text>
	</svg>
);
registerBlockType(metadata.name, {
	/**
	 * @see ./edit.js
	 */
	edit: Edit,
	icon: editorIcon,
});
